import SuperJSON from "superjson";
import Id from "../types/Id";

export default class UserId extends Id<"user"> {}

SuperJSON.registerClass(UserId);
